import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Phone from "../../Twilio/Phone";
import { useState } from "react";
import './index.css'

const CallModal = ({ showModal, handleClose, listData, phoneNumber, candidateUniqueId, getCallHistoryList, jobsClaimId, jobsShiftUniqueId }) => {
    
  const [callHistoryIndex, setcallHistoryIndex] = useState('');
  const [callHistoryFlag, setcallHistoryIndexFlag] = useState(false);
  const [callHistoryToggle, setCallHistoryToggle] = useState(false);

  return (
    <>
      <div id="userLocationModal">
        <Modal size="lg" show={showModal}>
          <Modal.Header>
            <Modal.Title>Call</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Phone phoneNumber={phoneNumber} candidateUniqueId={candidateUniqueId} getCallHistoryList={getCallHistoryList} handleClose={handleClose} jobsClaimId={jobsClaimId} jobsShiftUniqueId={jobsShiftUniqueId}/>

            {listData && listData?.length ? (
              <div className="mt-3">
                <div className="accordion" id="accordionExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                        onClick={() => setCallHistoryToggle(!callHistoryToggle)}
                      >
                        Call History
                      </button>
                    </h2>
{callHistoryToggle &&
                    <div
                      // id="collapseOne"
                      // class="accordion-collapse collapse "
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <div class="table-responsive">
                          <table class="table table-inbox table-hover text-nowrap mb-0">
                            <tbody>
                              {listData?.map((element, index) => {
                                return (
                                  <>
                                    <tr
                                      class="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-parent="#accordion"
                                      href={`#data_${index}`}
                                      aria-expanded="false"
                                      aria-controls={`data_${index}`}
                                      
                                    >
                                      <td>{element.callDateToDisplay}</td>
                                      <td className={`text-end`}>
                                        <audio
                                          controls
                                          style={{ height: "30px" }}
                                         className={`btn ${(callHistoryFlag === true && callHistoryIndex !== index) ? 'disableAudio' : ''}`}
                                        onPlay={() => {
                                          setcallHistoryIndexFlag(true);
                                          setcallHistoryIndex(index)
                                        }}
                                        onPause={() => {
                                          setcallHistoryIndexFlag(false);
                                        }}
                                        >
                                          <source
                                            src={element.voiceUrl}
                                            type="audio/mpeg"
                                            
                                          />
                                        </audio>
                                       
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div> }
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </Modal.Body>

          <Modal.Footer>
            <button className="btn btn-outline-primary" onClick={() => {
              handleClose()
              setCallHistoryToggle(false)
              }}>
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default CallModal;
